import React from 'react';
import withRouter from '../common/withRouter';
import { Link } from 'react-router-dom';
import { Button, Modal } from 'react-bootstrap';
import Form from '../common/form';
import { editField, removeField } from '../../services/customFieldService';
import { toast } from 'react-toastify';
import Joi from '@hapi/joi';
import { lowerCase } from 'lodash';

const FieldTypes = {
  Address: 'Address',
  Date: 'Date',
  Dropdown: 'Dropdown',
  Email: 'Email',
  FileLink: 'FileLink',
  Name: 'Name',
  Number: 'Number',
  Phone: 'Phone',
  Text: 'Text',
  TextArea: 'TextArea',
  Website: 'Website',
};

class EditCustomField extends Form {
  state = {
    show: false,
    data: {},
    errors: {},
    customOptions: [],
    nextCustomOptionId: 4,
    showSubOptions: false,
  };

  componentDidMount = () => {
    this.schema = {
      'Field name': Joi.string().valid(),
      'Field type': Joi.any(),
      'Field id': Joi.any(),
      required: Joi.boolean(),
    };
  };

  handleShow = () => {
    let { fieldData } = this.props;
    let { data, nextCustomOptionId } = this.state;
    let showSubOptions = data.showSubOptions,
      customOptions = data.customOptions || [];
    data['Field name'] = fieldData.Name;
    data['Field type'] = fieldData.Type;
    data['required'] = fieldData.IsRequired;
    data['Field id'] = fieldData._id;

    if (fieldData.Type === 'Dropdown') {
      showSubOptions = true;
      let options = [],
        i = 0;
      fieldData.Options.forEach((o) => {
        i++;
        let name = `Option ${i}`;
        options.push({ Name: name, Option: o.Option });
        data[name] = o.Option;
      });
      customOptions = [...customOptions, ...options];
      nextCustomOptionId = i + 1;
    }
    this.setState({
      show: true,
      data,
      showSubOptions,
      customOptions,
      nextCustomOptionId,
    });
  };

  handleClose = () => {
    this.setState({ show: false });
    this.props.doRefresh();
  };

  doSubmit = async () => {
    try {
      let { data, customOptions } = this.state;
      //this.setState(data);

      let field = JSON.stringify({
        Name: data['Field name'],
        _id: data['Field id'],
        IsRequired: data.required,
        Options: customOptions,
      });

      await editField(field);
    } catch (ex) {
      if (ex.response) {
        let errors = `${ex.response.status} - ${ex.response.statusText}: ${ex.response.data}`;
        this.setState({ errors });
        toast.error(errors);
      }
    }
    this.handleClose();
  };

  addClick = () => {
    this.setState((prevState) => ({
      customOptions: [
        ...prevState.customOptions,
        { Name: 'Option ' + prevState.nextCustomOptionId, Option: '' },
      ],
      nextCustomOptionId: prevState.nextCustomOptionId + 1,
    }));
  };

  removeClick = (ident) => {
    let { data, customOptions } = this.state;
    // let idx = customOptions.findIndex((co) => co.Name === ident);
    customOptions = customOptions.filter((co) => co.Name !== ident);
    delete data[ident];
    this.setState({ data, customOptions });
  };

  handleRemove = async () => {
    try {
      let { data } = this.state;

      let field = JSON.stringify({
        Name: data['Field name'],
        _id: data['Field id'],
        RecordType: this.props.RecordType,
        Type: data['Field type'],
        IsRequired: data.required,
        Options: [],
      });

      await removeField(field);
    } catch (ex) {
      if (ex.response) {
        let errors = `${ex.response.status} - ${ex.response.statusText}: ${ex.response.data}`;
        this.setState({ errors });
        toast.error(errors);
      }
    }
    this.handleClose();
  };

  subChange = async (input, selectData) => {
    const errors = { ...this.state.errors };
    let data = { ...this.state.data };
    let customOptions = [...this.state.customOptions];

    console.log(customOptions);

    if (input && input.currentTarget) {
      input = input.currentTarget;
    } else {
      const src = input;
      input = {};
      input.name = selectData.name;
      input.value = src;
    }

    let errorMsg = this.validateProperty(input);
    if (errorMsg) errors[input.name] = errorMsg;
    else delete errors[input.name];

    let idx = customOptions.findIndex((co) => co.Name === input.name);
    customOptions[idx].Option = input.value;
    data[input.name] = input.value;
    this.setState({ data, customOptions, errors });
  };

  doChange = async (input, selectData) => {
    let { customOptions } = this.state;

    if (
      input &&
      input.value &&
      input.value === 'Dropdown' &&
      customOptions.length === 0
    ) {
      this.setState({
        showSubOptions: true,
        customOptions: [
          ...this.state.customOptions,
          { Name: 'Option 1', Option: '' },
          { Name: 'Option 2', Option: '' },
          { Name: 'Option 3', Option: '' },
        ],
      });
    } else {
      this.setState({ showSubOptions: false, customOptions: [] });
    }
  };

  renderSubOptions() {
    let { showSubOptions } = this.state;
    return (
      <div className='mb-3'>
        {this.state.customOptions.map((opt, i) => {
          if (opt) {
            let id = parseInt(i) + 1;
            let ident = 'Option ' + id;
            this.schema[ident] = Joi.string().valid();
            return this.renderInput(
              'opt' + id,
              ident,
              ident,
              ident,
              false,
              'Text',
              'form-control',
              'mb-3 form-group input-group',
              this.subChange,
              'btn-outline-secondary',
              'Remove',
              this.removeClick.bind(this, ident)
            );
          }
        })}
        {showSubOptions ? (
          <Button variant='primary' onClick={this.addClick.bind(this)}>
            Add More
          </Button>
        ) : (
          ''
        )}
      </div>
    );
  }

  render() {
    let { show } = this.state;
    let options = [];
    for (let key in FieldTypes) {
      let field = {};
      field.label = key;
      field.value = FieldTypes[key];
      options.push(field);
    }

    return (
      <>
        Click-And-Drag to Re-Order
        <br />
        {this.props.fieldData.IsDefaultField === false ? (
          <Link to='#' onClick={this.handleShow}>
            Click Here To Edit
          </Link>
        ) : (
          ''
        )}
        <Modal size='lg' show={show} onHide={this.handleClose}>
          <Modal.Header>
            <Modal.Title>
              Edit custom {lowerCase(this.props.RecordType)} field
            </Modal.Title>
            <Button
              className='btn-close'
              onClick={this.handleClose}
              aria-label='Close'
            />
          </Modal.Header>
          <Modal.Body>
            <div
              id='EditCustomField'
              data-simplebar
              className='container-fluid'
            >
              <form
                id='EditCustomField-form'
                onSubmit={this.handleSubmit}
                className='row'
              >
                {this.renderInput(
                  'Field name 1',
                  'Field name',
                  'Field name',
                  ' ',
                  false,
                  'Text'
                )}
                <p>
                  This is a field type of{' '}
                  <strong>{this.props.fieldData.Type}</strong>
                </p>
                {this.renderSubOptions()}
                {this.renderInput(
                  'required',
                  'required',
                  'Make this field required',
                  'Make this field required',
                  false,
                  'checkbox',
                  'form-check-input',
                  'form-check custom-checkbox'
                )}
                {this.props.fieldData.IsDefaultField === false ? (
                  <Button variant='danger' onClick={this.handleRemove}>
                    Remove
                  </Button>
                ) : (
                  ''
                )}
              </form>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='light' onClick={this.handleClose}>
              Cancel
            </Button>
            <Button variant='primary' onClick={this.handleSubmit}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default withRouter(EditCustomField);
